import React from 'react';
import './BuyTag.scss';

const BuyTag = () => {
    return (
        <div className="buy-tag-container text-center">
            <img 
                data-src="https://static.retail.autofact.cl/surveys/buy-tag-fake-proccess.png" 
                height={40}
                width={640}
                className="lozad logo-comprar-tag"
                alt="Logo Autofact"
                />
        </div>
    );
};

export default BuyTag;